if (!customElements.get('card-rating')) {
  customElements.define('card-rating', class extends HTMLElement {
    connectedCallback() {
      const widget = this.querySelector('.custom-vstar-rating-widget');
      if (!widget) return;

      const update = () => {
        const stars = widget.querySelector('.vstar-star');
        const style = stars && getComputedStyle(stars);
        const visible = stars && stars.getBoundingClientRect().height > 0 &&
          style.display !== 'none' && style.visibility !== 'hidden' && style.opacity !== '0';
        this.toggleAttribute('data-app-rating', Boolean(visible));
      };

      this.mutationObserver = new MutationObserver(update);
      this.mutationObserver.observe(widget, { childList: true, subtree: true, attributes: true });
      this.resizeObserver = new ResizeObserver(update);
      this.resizeObserver.observe(widget);
      update();
    }

    disconnectedCallback() {
      this.mutationObserver?.disconnect();
      this.resizeObserver?.disconnect();
    }
  });
}
